// const baseURL = 'https://cx.yunnsoo.com'; //线上 安

// const baseURL="http://47.98.172.31:8848";
// const baseURL = "http://47.105.188.224:8052"  //测试地址

const baseURL = "https://e.yunnsoo.com:8082/"  //正式

const app = false; //运行环境
const state = 0;
const width = 1920;
export { baseURL, state, width, app, }


// WEBPACK FOOTER //
// ./src/service/config.js